// Toggle visibility of legends per chapter
export function toggleChapterLegend(config, activeChapterId) {
  if (!config.legend || config.inset) return;

  config.chapters.forEach((chap) => {
    const el = document.getElementById(chap.id + "Legend");
    if (el) {
      el.style.display = chap.id === activeChapterId ? "block" : "none";
    }
  });
}

// Move marker to chapter's location
export function moveMarker(marker, location) {
  if (!marker || !location?.center) return;
  marker.setLngLat(location.center);
}

// Enable or disable interactivity
export function handleMapInteractivity(map, isInteractive) {
  if (isInteractive) {
    // Only add navigation control if it doesn't already exist
    const hasNavControl = map._controls?.some(
      (c) => c instanceof maplibregl.NavigationControl
    );
    if (!hasNavControl) {
      const nav = new maplibregl.NavigationControl();
      map.addControl(nav, "bottom-left");
    }
    map.dragPan.enable();
    map.doubleClickZoom.enable();
    map.getCanvas().style.cursor = "grab";
  } else {
    map.dragPan.disable();
    map.doubleClickZoom.disable();
    map.getCanvas().style.cursor = "default";
    map._controls?.forEach((c) => map.removeControl(c));
  }
}

// Map rotation animation
export function rotateMap(map) {
  map.once("moveend", () => {
    const bearing = map.getBearing();
    map.rotateTo(bearing + 180, { duration: 30000, easing: (t) => t });
  });
}

// Globe spin animation
export function spinGlobe(map) {
  map.once("moveend", () => {
    const center = map.getCenter();
    const newCenter = [center.lng + 360, center.lat];
    map.easeTo({ center: newCenter, duration: 20000, easing: (n) => n });
  });
}
